<p>Crypto landing component works</p>